import IdentityBank from "./identityBank";
export default IdentityBank;